// Internal helper to generate a function to obtain property `key` from `obj`.
export default function shallowProperty(key) {
  return function(obj) {
    return obj == null ? void 0 : obj[key];
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/_shallowProperty.js
// module id = 513
// module chunks = 106